import React from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";

interface DevopsHubHeaderProps {
  title: string;
  description: string;
  search: string;
  onSearchChange: (value: string) => void;
  onAdd?: () => void;
  addLabel?: string;
}

const DevopsHubHeader: React.FC<DevopsHubHeaderProps> = ({
  title,
  description,
  search,
  onSearchChange,
  onAdd,
  addLabel = "Add",
}) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="h5" fontWeight={600}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
      {description}
    </Typography>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
      <TextField
        size="small"
        placeholder="Search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ flex: 1 }}
      />
      {onAdd && (
        <Button variant="contained" onClick={onAdd}>
          {addLabel}
        </Button>
      )}
    </Stack>
  </Box>
);

export default DevopsHubHeader;
